import { render, staticRenderFns } from "./UnhandledOrders.vue?vue&type=template&id=13e9df0a"
import script from "./UnhandledOrders.vue?vue&type=script&lang=js"
export * from "./UnhandledOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports